import React from "react";
import { observer } from "mobx-react";
import { generalConfigurationStore as store } from "../Stores/GeneralConfigurationStore";
import "./StepsNavigation.css";
import { Link } from "react-router-dom";


type Props = {
	pageIsActive: number;
	sublineStep1?: string;
	sublineStep2?: string;
	sublineStep3?: string;
};

@observer
class StepsNavigation extends React.Component<Props> {

	render() {
		return (
			<div className="steps-navigation">
				<button className="step-back" onClick={() => window.history.back()}></button>
				<Link
					to={this.props.pageIsActive >= 0 ? "/" : ""}
					className={`step ${this.props.pageIsActive === 0 ? "current" : ""} ${this.props.pageIsActive > 0 ? "clickable" : "disabled-link"}`}
				>
					<div className="step-wrapper">
						<p className="step-name mb-0 mb-lg-1">{store.configs?.toplineProduct}</p>
						<p className="step-dynamic mb-0">{store.productConfigurationStore?.product?.title?.rendered}</p>
					</div>
				</Link>
				<Link
					to={this.props.pageIsActive >= 1 ? "/" : ""}
					className={`step ${this.props.pageIsActive === 1 ? "current" : ""} ${this.props.pageIsActive > 1 ? "clickable" : "disabled-link"}`}
				>
					<div className="step-wrapper">
						<p className="step-name mb-0 mb-lg-1">{store.configs?.toplineEquipment}</p>
						{this.props.sublineStep1 && <p className="step-dynamic mb-0">{this.props.sublineStep1}</p>}
					</div>
				</Link>
				<Link
					to={this.props.pageIsActive >= 2 ? "/summary" : ""}
					className={`step ${this.props.pageIsActive === 2 ? "current" : ""} ${this.props.pageIsActive > 2 ? "clickable" : "disabled-link"}`}
				>
					<div className="step-wrapper">
						<p className="step-name mb-0 mb-lg-1">{store.configs?.toplineSummary}</p>
						{this.props.sublineStep2 && <p className="step-dynamic mb-0">{this.props.sublineStep2}</p>}
					</div>
				</Link>
				<Link
					to={this.props.pageIsActive >= 3 ? "/sales-partner" : ""}
					className={`step ${this.props.pageIsActive === 3 ? "current" : ""} ${this.props.pageIsActive > 3 ? "clickable" : "disabled-link"}`}
				>
					<div className="step-wrapper">
						<p className="step-name mb-0 mb-lg-1">{store.configs?.toplineSalesPartner}</p>
						{this.props.sublineStep3 && <p className="step-dynamic mb-0">{this.props.sublineStep3}</p>}
					</div>
				</Link>
				<Link
					to={this.props.pageIsActive >= 4 ? "" : ""}
					className={`step ${this.props.pageIsActive === 4 ? "current" : ""} ${this.props.pageIsActive > 4 ? "clickable" : "disabled-link"}`}
				>
					<div className="step-wrapper">
						<p className="step-name mb-0 mb-lg-1">{store.configs?.toplineRequest}</p>
					</div>
				</Link>
			</div>
		);
	}
}

export default StepsNavigation;
